<template>
	<div class="mortgage-calcnew__goalmobile" ref="goalmobile">
		<d-select
			v-model="goalmobile"
			:items="[
				{'const': 'buy', title: 'Покупка'},
				{'const': 'refin', title: 'Рефинансирование'},
				{'const': 'pledge', title: 'Под залог'},
			]"
		/>
	</div>
</template>

<script>
export default {
	name: "MortgageCalculatorGoalmobile",
	props: {
		combinations: {
			type: Array,
			default() {
				return []
			}
		}
	},
	data() {
		return {
			goalmobile: 'buy'
		}
	},
	methods: {
		checkProductsCombinations() {
			if (this.$refs.goalmobile) {
				const goalsMobile = this.$refs.goalmobile.querySelectorAll('.d-select__item');
				for (let i = 0; i < goalsMobile.length; i++) {
					const goalCode = goalsMobile[i].getAttribute('value');
					if (this.$props.combinations.indexOf(goalCode) !== -1) {
						goalsMobile[i].classList.add('hidden');
					}
					else {
						if (goalsMobile[i].classList.contains('hidden')) {
							goalsMobile[i].classList.remove('hidden');
						}
					}
				}
			}
		}
	},
	watch: {
		goalmobile(newValue) {
			this.checkProductsCombinations();
			this.$emit('setTabActive', newValue);
		},
		combinations() {
			this.checkProductsCombinations();
		}
	}
}
</script>
